import { TableCell, TableRow } from '@mui/material';

interface SkuCodePresenceRowProps {
  label: string;
  /** 未定義は appdb から取得できなかったことを表す */
  present: boolean | undefined;
}

/**
 * SKUマスターに商品コード（JAN・QR）が登録されているかを、アカウント設定テーブルの1行として表示する
 */
export function SkuCodePresenceRow({ label, present }: SkuCodePresenceRowProps) {
  return (
    <TableRow>
      <TableCell>{label}</TableCell>
      <TableCell sx={{ color: present == null ? 'text.disabled' : 'text.primary' }}>
        {present == null ? '不明' : present ? 'あり' : 'なし'}
      </TableCell>
    </TableRow>
  );
}
